import { trpc } from '@/shared/api/trpc';

export const useRemoveTourOperator = () => {
  const utils = trpc.useUtils();
  return trpc.operations.removeTourOperator.useMutation({
    onSettled: () => {
      utils.operations.tourOperatorsList.invalidate();
      utils.operations.tourOperatorAssignments.invalidate();
      // The delete also unassigns them from services (TCO-OPS03-002).
      utils.operations.list.invalidate();
      // Same table backs the CRM tour-operators list — keep it fresh too.
      utils.tourOperators.list.invalidate();
      utils.tourOperators.filterCounts.invalidate();
      utils.tourOperators.countriesCities.invalidate();
    },
  });
};
